(ns ui.editors.simple-filters.sub
  (:require-macros [ui.subs.macros :refer [<-1]])
  (:require
   [clojure.string :as string]
   [re-frame.core :as rf]
   [ui.editors.simple-filters.model :as model]
   [ui.state.session.sub :as session-sub]))

(def unary-operators
  #{:operand/known
    :operand/unknown
    :operand/true
    :operand/false})

(defn- meaningful-value?
  [value]
  (cond
    (nil? value) false
    (string? value) (not (string/blank? value))
    (coll? value) (seq value)
    :else true))

(defn- active-selection?
  [selection]
  (boolean
   (or (meaningful-value? (:value selection))
       (and (meaningful-value? (:from selection))
            (meaningful-value? (:to selection)))
       (contains? unary-operators (:operator selection)))))

(rf/reg-sub
 ::runtime
 (fn [db [_ editor-id]]
   (get-in db (model/editor-path editor-id))))

(rf/reg-sub
 ::default-currency
 (fn [_ _]
   (rf/subscribe [::session-sub/tenant]))
 (fn [tenant _]
   (:tenant/default-currency tenant)))

(rf/reg-sub
 ::context
 (<-1 ::runtime)
 (fn [runtime _]
   (get runtime model/context-key)))

(rf/reg-sub
 ::preference-context
 (<-1 ::runtime)
 (fn [runtime _]
   (get runtime model/preference-context-key)))

(rf/reg-sub
 ::fields
 (<-1 ::runtime)
 (fn [runtime _]
   (get runtime model/fields-key)))

(rf/reg-sub
 ::fields-status
 (<-1 ::fields)
 (fn [fields _]
   (get fields :status)))

(rf/reg-sub
 ::fields-error
 (<-1 ::fields)
 (fn [fields _]
   (get fields :error)))

(rf/reg-sub
 ::fields-search-text
 (<-1 ::fields)
 (fn [fields _]
   (get fields :search-text)))

(rf/reg-sub
 ::field-paths
 (<-1 ::fields)
 (fn [fields _]
   (get fields :ordered-paths)))

(rf/reg-sub
 ::field-by-path
 (<-1 ::fields)
 (fn [fields [_ _editor-id field-path]]
   (let [field (get-in fields [:by-path field-path])]
     (js/console.log "[simple-filters.sub] field-by-path"
                     #js {:fieldPath (pr-str field-path)
                          :hasField (boolean field)
                          :fieldDataType (str (:field/data-type field))
                          :fieldFilterType (str (:field/filter-type field))
                          :fieldPathInField (pr-str (:field-path field))})
     field)))

(rf/reg-sub
 ::field-data-type
 (<-1 ::field-by-path)
 (fn [field _]
   (let [data-type (:field/data-type field)]
     (js/console.log "[simple-filters.sub] field-data-type"
                     #js {:dataType (str data-type)
                          :fieldPathInField (pr-str (:field-path field))
                          :fieldLabel (or (:field/label field) (:field/name field))})
     data-type)))

(rf/reg-sub
 ::field-filter-type
 (<-1 ::field-by-path)
 (fn [field _]
   (let [filter-type (:field/filter-type field)]
     (js/console.log "[simple-filters.sub] field-filter-type"
                     #js {:filterType (str filter-type)
                          :fieldPathInField (pr-str (:field-path field))
                          :fieldLabel (or (:field/label field) (:field/name field))})
     filter-type)))

(rf/reg-sub
 ::field-options
 (<-1 ::field-by-path)
 (fn [field _]
   (or (:field/options field)
       (:options field)
       [])))

(rf/reg-sub
 ::po
 (<-1 ::runtime)
 (fn [runtime _]
   (get runtime model/po-key)))

(rf/reg-sub
 ::po-configured-field-paths
 (<-1 ::po)
 (fn [po _]
   (get po :configured-field-paths)))

(rf/reg-sub
 ::po-visible-field-paths
 (<-1 ::po)
 (fn [po _]
   (get po :visible-field-paths)))

(rf/reg-sub
 ::pinned
 (<-1 ::runtime)
 (fn [runtime _]
   (get runtime model/pinned-key)))

(rf/reg-sub
 ::pinned-field-paths
 (<-1 ::pinned)
 (fn [pinned _]
   (get pinned :field-paths)))

(rf/reg-sub
 ::pinned-saving?
 (<-1 ::pinned)
 (fn [pinned _]
   (true? (get pinned :saving?))))

(rf/reg-sub
 ::pinned-error
 (<-1 ::pinned)
 (fn [pinned _]
   (get pinned :error)))

(rf/reg-sub
 ::sections
 (<-1 ::runtime)
 (fn [runtime _]
   (get runtime model/sections-key)))

(rf/reg-sub
 ::po-section-field-paths
 (<-1 ::sections)
 (fn [sections _]
   (get sections :po-field-paths)))

(rf/reg-sub
 ::pinned-section-field-paths
 (<-1 ::sections)
 (fn [sections _]
   (get sections :pinned-field-paths)))

(rf/reg-sub
 ::runtime-section-field-paths
 (<-1 ::sections)
 (fn [sections _]
   (get sections :runtime-field-paths)))

(rf/reg-sub
 ::all-visible-field-paths
 (<-1 ::sections)
 (fn [sections _]
   (vec (concat (get sections :po-field-paths)
                (get sections :pinned-field-paths)
                (get sections :runtime-field-paths)))))

(rf/reg-sub
 ::section-items
 (<-1 ::sections)
 (fn [sections _]
   [{:section-key :po
     :field-paths (get sections :po-field-paths)}
    {:section-key :pinned
     :field-paths (get sections :pinned-field-paths)}
    {:section-key :runtime
     :field-paths (get sections :runtime-field-paths)}]))

(rf/reg-sub
 ::filters
 (<-1 ::runtime)
 (fn [runtime _]
   (get runtime model/filters-key)))

(rf/reg-sub
 ::facets
 (<-1 ::runtime)
 (fn [runtime _]
   (get runtime model/facets-key)))

(rf/reg-sub
 ::facets-by-field-path
 (<-1 ::facets)
 (fn [facets _]
   (get facets :by-field-path)))

(rf/reg-sub
 ::field-facet-options
 (<-1 ::facets-by-field-path)
 (fn [facets-by-field-path [_ _editor-id field-path]]
   (get facets-by-field-path field-path [])))

(rf/reg-sub
 ::loading-facets-by-field-path
 (<-1 ::facets)
 (fn [facets _]
   (get facets :loading-by-field-path)))

(rf/reg-sub
 ::has-more-facets-by-field-path
 (<-1 ::facets)
 (fn [facets _]
   (get facets :has-more-by-field-path)))

(rf/reg-sub
 ::field-facets-has-more?
 (<-1 ::has-more-facets-by-field-path)
 (fn [has-more-by-field-path [_ _editor-id field-path]]
   (true? (get has-more-by-field-path field-path))))

(rf/reg-sub
 ::field-facets-loading?
 (<-1 ::loading-facets-by-field-path)
 (fn [loading-by-field-path [_ _editor-id field-path]]
   (true? (get loading-by-field-path field-path))))

(rf/reg-sub
 ::facets-error-by-field-path
 (<-1 ::facets)
 (fn [facets _]
   (get facets :error-by-field-path)))

(rf/reg-sub
 ::field-facets-error
 (<-1 ::facets-error-by-field-path)
 (fn [error-by-field-path [_ _editor-id field-path]]
   (get error-by-field-path field-path)))

(rf/reg-sub
 ::filters-by-field-path
 (<-1 ::filters)
 (fn [filters _]
   (get filters :by-field-path)))

(rf/reg-sub
 ::field-filter
 (<-1 ::filters-by-field-path)
 (fn [filters-by-field-path [_ _editor-id field-path]]
   (get filters-by-field-path field-path)))

(rf/reg-sub
 ::field-selections
 (<-1 ::field-filter)
 (fn [field-filter _]
   (get field-filter :selections)))

(rf/reg-sub
 ::active-selection-count
 (<-1 ::runtime)
 (fn [runtime _]
   (->> (get-in runtime [:filters :by-field-path] {})
        (vals)
        (map (fn [field-filter]
               (->> (or (get field-filter :selections) [])
                    (filter active-selection?)
                    count)))
        (reduce + 0))))

(rf/reg-sub
 ::ui
 (<-1 ::runtime)
 (fn [runtime _]
   (get runtime model/ui-key)))

(rf/reg-sub
 ::open-field-path
 (<-1 ::ui)
 (fn [ui _]
   (get ui :open-field-path)))

(rf/reg-sub
 ::field-picker-open?
 (<-1 ::ui)
 (fn [ui _]
   (true? (get ui :field-picker-open?))))

(rf/reg-sub
 ::reset-count
 (<-1 ::ui)
 (fn [ui _]
   ;; Goes up when all the filters are cleared. See `event/clear-all-filters-fx`.
   (get ui :reset-count 0)))

(rf/reg-sub
 ::field-picker-search-text
 (<-1 ::ui)
 (fn [ui _]
   (get ui :field-picker-search-text)))

(rf/reg-sub
 ::option-search-text-by-field
 (<-1 ::ui)
 (fn [ui _]
   (get ui :option-search-text-by-field)))

(rf/reg-sub
 ::option-search-text
 (<-1 ::option-search-text-by-field)
 (fn [option-search-text-by-field [_ _editor-id field-path]]
   (get option-search-text-by-field field-path "")))

(rf/reg-sub
 ::busy-by-key
 (<-1 ::ui)
 (fn [ui _]
   (get ui :busy-by-key)))

(rf/reg-sub
 ::busy?
 (<-1 ::busy-by-key)
 (fn [busy-by-key [_ _editor-id busy-key]]
   (true? (get busy-by-key busy-key))))
